'use client'
import React, { useState } from 'react';
import Head from 'next/head'
import Image from 'next/image'
import Link from 'next/link';
import NavBarLanding from '@/components/NavBarLanding';
import Footer from '@/components/Footer';
import { SignFrom } from '@/components/Sign';

export default function Usage() {
    const [signValue, setSignValue] = useState<string>('signup');
    const [toggleSignForm, setToggleSignForm] = useState<boolean>(false);
    const CGVData = {
        "CGV": [
            {
                "article": "Article 1 : Objet",
                "description": "Les présentes CGV ont pour objet de définir les conditions dans lesquelles Jean Choquet, micro-entrepreneur domicilié au 10 rue d'Armorique, Arzon 56640, fournit ses services à ses clients via son logiciel SaaS, Eurekia."
            },
            {
                "article": "Article 2 : Disponibilité et Assistance",
                "description": "Jean Choquet s'efforce d'assurer la disponibilité du service Eurekia 24h/24, 7j/7. Toutefois, nous ne pouvons être tenus responsables des interruptions de service dues à des problèmes de connexion internet. En cas de suspension ou d'interruption des services, notre prestataire sera tenu responsable. Une assistance technique est disponible en ligne."
            },
            {
                "article": "Article 3 : Mises à jour et Formation",
                "description": "Les clients seront informés de toute mise à jour du logiciel Eurekia. Un guide d'utilisation sera fourni en cas de mise à jour majeure."
            },
            {
                "article": "Article 4 : Tarification et Abonnement",
                "description": "Les clients peuvent choisir parmi les options d'abonnement suivantes: - 19,90 euros pour 100 000 crédits - 29,90 euros pour 230 000 crédits. Eurekia fonctionne avec un système de crédits qui impose des limitations d'usage selon le plan choisi."
            },
            {
                "article": "Article 5 : Période d'essai",
                "description": "Les nouveaux clients bénéficient d'une période d'essai gratuite d'un mois. Après cette période, l'abonnement choisi sera facturé mensuellement."
            },
            {
                "article": "Article 6 : Annulation",
                "description": "Les clients peuvent annuler leur abonnement à tout moment. L'annulation prend effet à la fin du cycle d'abonnement en cours, sans frais supplémentaires."
            },
            {
                "article": "Article 7 : Données personnelles",
                "description": "Nous nous engageons à traiter vos données personnelles conformément à la réglementation en vigueur en France. Les clients seront informés de toute faille de sécurité pouvant affecter leurs données."
            },
            {
                "article": "Article 8 : Sécurité",
                "description": "Jean Choquet s'engage à assurer la sécurité maximale lors de la collecte et du traitement des données sur Eurekia. Les clients peuvent demander une copie intégrale de leurs données à tout moment."
            },
            {
                "article": "Article 9 : Réversibilité",
                "description": "En cas de résiliation du contrat de service, la réversibilité des données est garantie. Un plan détaillé de réversibilité est disponible sur demande."
            },
            {
                "article": "Article 10 : Lois applicables",
                "description": "Les présentes CGV sont régies par la loi française. Tout litige relatif à leur interprétation et/ou à leur exécution est soumis aux tribunaux français."
            }
        ]
    };


    return (
        <>
            <Head>
                <title>Eurekia !</title>
                <meta name="description" content="Generated by webzh" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <link rel="icon" href="/favicon.ico" />
            </Head>

            <main className="w-full items-center justify-center flex-col bg-main relative gap-4">
                {
                    toggleSignForm ?

                        <div className='w-full sm:h-full h-screen flex justify-center items-center'>
                            <style global jsx>{`
    #__next {
        height:100vh;
        width:100vw;
        overflow:hidden
      }
`}</style>
                            <div onClick={() => setToggleSignForm(false)} className='z-50 w-full h-full fixed top-0 left-0 flex justify-center items-center backdrop-blur-md bg-black bg-opacity-10'>
                            </div>
                            <div className='z-[1000] fixed flex justify-center'>
                                <SignFrom signValue={signValue} />
                            </div>
                        </div>
                        : null
                }
                < NavBarLanding
                    signValue={signValue as string}
                    setSignValue={setSignValue}
                    toggleSignForm={toggleSignForm}
                    setToggleSignForm={setToggleSignForm}
                />
                <section className="w-full flex flex-col items-center h-auto pt-[150px]">

                    <h1 className='font-medium text-3xl lg:text-[2.4vw] leading-tight flex sm:items-start items-center justify-center flex-col text-center'>
                        Conditions d'Utilisation
                    </h1>
                    <div className=" p-8 w-full max-w-3xl mx-auto rounded shadow-lg">
                        <h1 className="text-2xl font-bold mb-6">Conditions Générales de Vente (CGV) de Eurekia</h1>

                        {CGVData.CGV.map((item, index) => (
                            <React.Fragment key={index}>
                                <h2 className="text-xl font-semibold mt-4 mb-4">{item.article}</h2>
                                <p className="mb-4">{item.description}</p>
                            </React.Fragment>
                        ))}

                    </div>
                </section>
                <Footer />

            </main>
        </>
    )
}
